import { useEffect, useState } from "react";
import { Button } from "@/components/ui/Button";
import { Modal } from "@/components/ui/Modal";
import { useRejectOfficialFee } from "../hooks/useOfficialFees";

/** Backend's OfficialFeeRejectSerializer: rejection_comment min_length=5. */
const MIN_REJECTION_COMMENT = 5;

/**
 * „Odrzuć prośbę o opłatę" (powód obowiązkowy) — jedno okno dla listy opłat, strony opłaty
 * i zbiorczego „Do zatwierdzenia" dyrektora.
 */
export function OfficialFeeRejectModal({
  feeId,
  open,
  onClose,
  onRejected,
}: {
  feeId: string | null;
  open: boolean;
  onClose: () => void;
  onRejected?: () => void;
}) {
  const rejectMut = useRejectOfficialFee();
  const [rejectComment, setRejectComment] = useState("");

  useEffect(() => {
    if (open) setRejectComment("");
  }, [open, feeId]);

  async function handleReject() {
    if (!feeId || !rejectComment.trim()) return;
    await rejectMut.mutateAsync({ id: feeId, rejection_comment: rejectComment });
    onRejected?.();
    onClose();
  }

  return (
    <Modal open={open} onClose={onClose} title="Odrzuć prośbę o opłatę">
      <div className="space-y-4">
        <label className="block text-sm font-medium text-[var(--color-text-primary)]">
          Powód odrzucenia <span className="text-red-500">*</span>
        </label>
        <textarea
          className="w-full rounded border border-[var(--color-border)] px-3 py-2 text-sm min-h-[80px] bg-[var(--color-bg-input)] text-[var(--color-text-primary)]"
          placeholder="Uzasadnij odrzucenie..."
          value={rejectComment}
          onChange={(e) => setRejectComment(e.target.value)}
        />
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>
            Anuluj
          </Button>
          <Button
            variant="danger"
            disabled={rejectComment.trim().length < MIN_REJECTION_COMMENT || rejectMut.isPending}
            onClick={handleReject}
          >
            Odrzuć
          </Button>
        </div>
      </div>
    </Modal>
  );
}
